import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { TextLink } from '~/techstyle-shared/react-components/src/TextLink/TextLink';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import SimpleHeaderTemplateSavage from '../SimpleHeaderTemplateSavage';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const PageBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: ${({ theme }) => theme.colors.palette.lavender100};
  flex: 1 1 auto;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  max-width: 256px;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 500;
  line-height: 0.8;
  letter-spacing: 1px;
`;

const Message = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  font-kerning: none;
`;

const HomeLink = styled(TextLink)`
  font-size: 18px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.palette.lavender500};
  text-transform: capitalize;
`;

export default function NotFoundSavage({ className }) {
  const homeLink = (
    <HomeLink href="/">
      <FormattedMessage id="site_error.home_link" defaultMessage="home" />
    </HomeLink>
  );

  return (
    <Wrapper className={className}>
      <SimpleHeaderTemplateSavage />
      <PageBody>
        <Content>
          <Title>
            <FormattedMessage
              id="site_error.error_page_title"
              defaultMessage="Uh-Oh"
            />
          </Title>
          <Message>
            <FormattedMessage
              id="site_error.error_page_body_404"
              defaultMessage="We couldn't find that page. Please go {homeLink} and try again."
              values={{ homeLink }}
            />
          </Message>
        </Content>
      </PageBody>
    </Wrapper>
  );
}

NotFoundSavage.propTypes = {
  className: PropTypes.string,
};
